
import { Button } from "@/components/ui/button";
import { RSVPButton } from "@/components/ui/rsvp-button";
import { navigationService } from "@/services/navigationService";
interface CreateEventButtonProps {
  onClick: () => void;
  disabled: boolean;
  isPending: boolean;
}
export const CreateEventButton = ({
  onClick,
  disabled,
  isPending
}: CreateEventButtonProps) => {
  const handleDiscard = () => {
    navigationService.goToHome();
  };
  return <div className="fixed bottom-0 left-0 right-0 p-4 pb-12 bg-gradient-to-t from-white via-white to-transparent">
      <div className="max-w-2xl mx-auto px-4 flex flex-col gap-3">
        <RSVPButton onClick={onClick} disabled={disabled} className="mx-auto w-60 flex items-center justify-center gap-2 transform transition-transform duration-150">
          {isPending ? "Creating Plan..." : "Create Plan"}
        </RSVPButton>
        
        <Button variant="outline" onClick={handleDiscard} className="mx-auto block w-60 flex items-center justify-center">
          Discard
        </Button>
      </div>
    </div>;
};
